import React, { useState, useEffect } from "react";

type LabeledTextareaProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  rows?: number;
  required?: boolean;
  showValidation?: boolean;
};

export default function LabeledTextarea({
  label,
  value,
  onChange,
  rows = 4,
  required = false,
  showValidation = false,
}: LabeledTextareaProps) {
  const [textareaValue, setTextareaValue] = useState(value);
  const [touched, setTouched] = useState(required || showValidation);

  // ✅ Verificar se o campo está vazio e é obrigatório
  const isEmpty = !textareaValue || String(textareaValue).trim() === '';
  const showError = required && isEmpty && (touched || showValidation);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    setTextareaValue(val);
    onChange(val);
  };

  const handleBlur = () => {
    setTouched(true);
  };

  // ✅ Sincronizar com valor externo
  useEffect(() => {
    setTextareaValue(value);
  }, [value]);

  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </span>

      <textarea
        placeholder="Digite aqui detalhes da O.S."
        rows={rows}
        value={textareaValue}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        aria-required={required}
        className={`rounded border px-4 py-3 outline-none transition-colors resize-vertical ${showError}`}
      />

      {/* ✅ Mostrar erro se for obrigatório e estiver vazio */}
     
    </label>
  );
}